import type { CustomIconProps } from '../types';

const UseMyLocation = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 10.9753C8.86221 10.7408 10.7408 8.86221 10.9753 6.5L9 6.5V5.5H10.9753C10.7408 3.13779 8.86221 1.25922 6.5 1.02469V3H5.5V1.02469C3.13779 1.25922 1.25922 3.13779 1.02469 5.5H3V6.5L1.02469 6.5C1.25922 8.86221 3.13779 10.7408 5.5 10.9753V9H6.5V10.9753ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
            fill="#414042"
        />
    </svg>
);

export default UseMyLocation;
